import React, { useState, useEffect, useRef } from "react";
import { FaBars } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "./modals/LoginModal.jsx";
import { useAuth } from "../contexts/AuthContextProvider.jsx";
import { routesConfig } from "../config/routesConfig.js";
import { showSuccessToast } from "../services/toastService.js";
import ProfileModal from "./modals/ProfileModal.jsx";

export default function NavBar() {
	const [menuOpen, setMenuOpen] = useState(false);
	const [modalLoginOpen, setModalLoginOpen] = useState(false);
	const [ProfileModalOpen, setProfileModalOpen] = useState(false);
	const menuRef = useRef(null);
	const { user, logout, notifications } = useAuth();
	const navigate = useNavigate();

	// Gestione del click fuori dal menu
	const handleClickOutside = (event) => {
		if (menuRef.current && !menuRef.current.contains(event.target)) setMenuOpen(false);
	};

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleLogout = () => {
		logout();
		showSuccessToast("Logout effettuato con successo!");
		navigate("/");
	};

	// Mappa notifiche in base alla route
	const getNotificationCount = (key) => {
		const notification = notifications?.find((n) => n.type === key);
		return notification ? notification.count : 0;
	};

	return (
		<>
			<header className="bg-blue-700 text-white py-6 px-4 rounded-lg shadow-lg mb-8 flex items-center justify-between relative">
				<Link to="/">
					<h1 className="text-xl lg:text-3xl font-extrabold">
						Sistema di Monitoraggio, Informazione ed Allerta Atri (SMIAA)
					</h1>
					<p className="text-md lg:text-lg font-light mt-2">
						A cura della <strong>Protezione Civile ANA Atri</strong>
					</p>
				</Link>

				<div ref={menuRef} className="relative z-40">
					<div className="relative">
						{/* Icona Menu */}
						<button
							id="menu"
							aria-label="menu"
							onClick={() => setMenuOpen((prev) => !prev)}
							className="text-white hover:text-gray-200 focus:outline-none relative"
						>
							<FaBars size={24} />
							{/* Pallino di Notifica */}
							{notifications.find((n) => n.type === "total")?.count > 0 && (
								<span className="absolute top-[-15px] right-[-15px] bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
									{notifications.find((n) => n.type === "total")?.count}
								</span>
							)}
						</button>
					</div>

					{/* Menu Dropdown */}
					{menuOpen && (
						<div className="absolute right-0 mt-2 w-60 bg-white text-gray-800 rounded-lg shadow-lg z-10">
							<ul className="py-2">
								{!user ? (
									<li
										className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
										onClick={() => {
											setMenuOpen(false);
											setModalLoginOpen(true);
										}}
									>
										Login
									</li>
								) : (
									<>
										{routesConfig
											.filter(
												(route) =>
													route.showInMenu &&
													(!route.requiresAuth ||
														(user &&
															user.level <= (route.minLevel || 2)))
											)
											.map((route, index) => (
												<Link
													key={index}
													to={route.route}
													onClick={() => setMenuOpen(false)}
												>
													<li className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2">
														<span>{route.name}</span>
														{/* Mostra notifica se presente */}
														{getNotificationCount(
															route.notification_key
														) > 0 && (
															<span className=" bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
																{getNotificationCount(
																	route.notification_key
																)}
															</span>
														)}
													</li>
												</Link>
											))}
										<li
											className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
											onClick={() => {
												setMenuOpen(false);
												setProfileModalOpen(true);
											}}
										>
											Profilo
										</li>
										<li
											className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
											onClick={() => {
												setMenuOpen(false);
												handleLogout();
											}}
										>
											Logout
										</li>
									</>
								)}
							</ul>
						</div>
					)}
				</div>
			</header>

			{modalLoginOpen && !user && <LoginModal close={() => setModalLoginOpen(false)} />}
			{ProfileModalOpen && user && <ProfileModal close={() => setProfileModalOpen(false)} />}
		</>
	);
}
